module.exports = __webpack_public_path__ + "videos/video-768.73918d0.webm";